import { useTranslation } from 'react-i18next';
import { QueryErrorState } from '@/components/admin/shared/QueryErrorState';
import { WorkspaceAssistantConfigurationForm } from '@/components/assistantConfiguration/WorkspaceAssistantConfigurationForm';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { useWorkspaceAssistantConfigurationQuery } from '@/hooks/useAssistantConfiguration';

export function AssistantSettingsSection() {
  const { t } = useTranslation('assistant');
  const configurationQuery = useWorkspaceAssistantConfigurationQuery(true);

  if (configurationQuery.isLoading === true) {
    return (
      <div className="py-16 flex justify-center">
        <LoadingSpinner className="w-7 h-7" />
      </div>
    );
  }

  if (configurationQuery.isError === true || configurationQuery.data === undefined) {
    return (
      <QueryErrorState
        onRetry={function retry() {
          configurationQuery.refetch();
        }}
      />
    );
  }

  return (
    <div>
      <h2 className="text-sm font-bold text-zooindigo">{t('configuration.workspaceTitle')}</h2>
      <p className="text-xs text-zoomuted mt-1 mb-5">{t('configuration.workspaceSubtitle')}</p>
      <WorkspaceAssistantConfigurationForm configuration={configurationQuery.data} />
    </div>
  );
}
